module.exports = __webpack_public_path__ + "img/0de880f7041fa66b874e3cd31170897f.svg";